
/**
 * ユーザーIDは4文字以上20文字以内
 */
export const userIdRegExp = new RegExp(/^[a-zA-Z0-9]{4,20}$/);
export const userIdConstraintErrorMessage = '有効なIDを入力してください';
export const userIdConstraintMessage = '半角英数字の4文字以上20文字以内';

/**
 * パスワードは半角大小文字英数字を1文字ずつ含む8文字以上
 */
export const passwordRegExp = new RegExp(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[!-~]{8,}$/);
export const passwordConstraintErrorMessage = '有効なパスワードを入力してください';
export const passwordConstraintMessage = '半角大小文字英数字を1文字ずつ含む8文字以上';

/**
 * メールアドレスの正規表現
 */
export const mailAddressRegExp = new RegExp(/^([\w!#$%&'*+\-\/=?^`{|}~]+(\.[\w!#$%&'*+\-\/=?^`{|}~]+)*|"([\w!#$%&'*+\-\/=?^`{|}~. ()<>\[\]:;@,]|\\[\\"])+")@(([a-zA-Z\d\-]+\.)+[a-zA-Z]+|\[(\d{1,3}(\.\d{1,3}){3}|IPv6:[\da-fA-F]{0,4}(:[\da-fA-F]{0,4}){1,5}(:\d{1,3}(\.\d{1,3}){3}|(:[\da-fA-F]{0,4}){0,2}))\])$/);
export const mailAddressLengthLimit = 255;
export const mailAddressConstraintErrorMessage = '有効なメールアドレスを入力してください';

/**
 * 携帯電話番号の正規表現
 */
export const authPhoneNumberRegExp = new RegExp(/^0\d{10}$/);
export const authPhoneNumberLengthLimit = 11;
export const authPhoneNumberConstraintErrorMessage = '有効な電話番号を入力してください';

/**
 * 認証コードの正規表現
 */
export const codeRegExp = new RegExp(/^[0-9]{4}$/);
export const codeLengthLimit = 4;
export const codeConstraintErrorMessage = '有効な認証コードを入力してください';

/**
 * 法人認証コードの正規表現
 */
export const mailCodeRegExp = new RegExp(/^[0-9]{6}$/);
export const mailCodeLengthLimit = 6;
export const mailCodeConstraintErrorMessage = '有効な認証コードを入力してください';

/**
 * 法人IDの正規表現
 */
export const CorporateIdRegExp = new RegExp(/^[a-zA-Z0-9]{4,30}$/);
export const CorporateIdConstraintMessage = '半角英数字の4文字以上30文字以内';
